export const newPoint = {
  " De onde você está trabalhando hoje?": " De onde você está trabalhando hoje?",
  "Casa": "Casa",
  "Escritório": "Escritório",
  "Outro": "Outro",
  "Selecione o motivo do ponto por exceção": "Selecione o motivo do ponto por exceção",
  "Selecione em que local você está": "Selecione em que local você está",
  "Marcar Ponto": "Marcar Ponto",
  "Último ponto": "Último ponto",
  "Ponto em processamento": "Ponto em processamento",
  "Seu ponto das": "Seu ponto das",
  "já foi registrado!": "já foi registrado!",
  "Atualize a página para visualizar o ponto.": "Atualize a página para visualizar o ponto.",
  "Atualizar página": "Atualizar página",
  "Horas trabalhadas": "Horas trabalhadas",
  "Seu turno está registrado como ": "Seu turno está registrado como ",
  "Você não interagiu com essa página por mais de 2 minutos. Clique no botão para atualizar a página.": "Você não interagiu com essa página por mais de 2 minutos. Clique no botão para atualizar a página.",
  "Houve um registro a menos de 5 minutos ": "Houve um registro a menos de 5 minutos ",
  "Você possui um afastamento hoje:": "Você possui um afastamento hoje:",
  "Tem certeza que deseja marcar seu ponto": "Tem certeza que deseja marcar seu ponto",
  "Selecione qual ponto você deseja marcar:": "Selecione qual ponto você deseja marcar:",
  "Entrada": "Entrada",
  "Saída intervalo": "Saída intervalo",
  "Volta intervalo": "Volta intervalo",
  "Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?": "Seu último ponto foi uma entrada, tem certeza que deseja marcar novamente?",
  "Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?": "Seu último ponto foi uma saída intevalo, tem certeza que deseja marcar novamente?",
  "Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?": "Seu último ponto foi uma volta intervalo, tem certeza que deseja marcar novamente?",
  "Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?": "Seu último ponto foi uma saída, tem certeza que deseja marcar novamente?",
  "Cancelar": "Cancelar",
  "Confirmar": "Confirmar",
  "Selecione o local que você está para marcar seu ponto.": "Selecione o local que você está para marcar seu ponto.",
  "Selecione o motivo do ponto por exceção para marcar seu ponto.": "Selecione o motivo do ponto por exceção para marcar seu ponto.",
  "Aguarde um instante que logo seu ponto será confirmado!": "Aguarde um instante que logo seu ponto será confirmado!",
  "Usuário rejeitou a solicitação de Geolocalização.": "Usuário rejeitou a solicitação de Geolocalização.",
  "Webcam not supported on this browser": "Webcam not supported on this browser",
  "Registro de ponto": "Registro de ponto",
  "Parece que você ficou ausente": "Parece que você ficou ausente",
  "Marcar ponto novamente?": "Marcar ponto novamente?",
  "Sim, continuar": "Sim, continuar",
  "Marcar ponto em afastamento": "Marcar ponto em afastamento"
};



// WEBPACK FOOTER //
// ./src/resources/ptBR/newPoint.js